export default __webpack_public_path__ + "static/tomchalancon_CV-b3b22c3a7e0fca1ca1ee6b786a2f7498.pdf";